<template>
	<div>
		<div style="width:1200px;margin: 0 auto;">
			<div class="dingdan">
				<el-breadcrumb separator-class="el-icon-arrow-right">
				  <el-breadcrumb-item>我的订单</el-breadcrumb-item>
				  <el-breadcrumb-item :to="{ path: '/serviceHome/serviceOrder/orderDatails?o_id='+datails.o_id}">我的订单</el-breadcrumb-item>
				  <el-breadcrumb-item>评审详情</el-breadcrumb-item>
				</el-breadcrumb>
				<div class="fh_button" @click="fanhui">
					<i class="el-icon-arrow-left"></i>
					<p>返回</p>
				</div>
			</div>
			<div class="ReviewDatails">
				<h3 class="ReviewH3">发起评审的阶段</h3>
				<div class="Reviewdiv">
					  需求方在
					  <span v-if="datails.stage==1">承认图 </span> 
					  <span v-else>生产图</span>阶段发起了评审，请您在 
					  <CountDown :endTime="datails.defense_expire_time*1000"/> 内提交评审材料
				</div>
			</div>
			<div class="ReviewDatails">
				<h3 class="ReviewH3">需求详情</h3>
				<div class="Reviewdiv1"> 
				    {{demand.description}}
				</div>
				<div class="Reviewdiv2">
					<div class="Reviewdiv2_1">
						<h4>相关图片</h4>
						<div>
							<imglist :file="demand.file"></imglist>
							<figure v-if="(demand.file || []).length==0" style="width:100%;text-align: center;">
								<img src="@/assets/kong.png" alt="" srcset="" />
							</figure>
						</div>
					</div>
					<div  class="Reviewdiv2_1">
						<h4>验收标准</h4>
						<div style="display:flex;">
							<div style="position:relative;margin-top:0;">
								<imglist :file="[datails.order.demand.confirm_image]" v-if="datails.order.demand.confirm_image"  width="72px" height="72px"></imglist>
								<img src="@/assets/kong.png" alt="" srcset="" v-if="!datails.order.demand.confirm_image"  style="width:72px;height:72px;margin-right:10px;border-radius:6px;margin-top:0;"/>
								<div style="" class="dingwei">承认图</div>
							</div>
							
							<div style="position:relative;margin-top:0;">
								<imglist :file="[datails.order.demand.produce_image]" v-if="datails.order.demand.confirm_image"  width="72px" height="72px"></imglist>
								<img src="@/assets/kong.png" alt="" srcset="" v-if="!datails.order.demand.confirm_image"  style="width:72px;height:72px;margin-right:10px;border-radius:6px;margin-top:0;"/>
								<div style="" class="dingwei">生产图</div>
							</div>
						</div>
						
					</div>
				</div>
			</div>
<!-- 			<div class="ReviewDatails">
				<h3 class="ReviewH3">验收相关信息</h3>
				<div class="ReviewView">
					<p>服务方提交内容 <span>（根据中标时间进行计算，完成周期剩余时间 每个阶段仅支持服务方提交五次附件）</span></p>
				</div>
				<ul class="ReviewUl">
					<li>中标时间：<span>{{datails.order.create_time}}</span></li>
					<li>服务方交付周期：<span>{{datails.order.period_format}}</span></li>
					<li>一阶段承认图：<span>{{datails.review.orderStage.period_format}}</span></li>
					<li>二阶段生产图：<span>{{datails.review.orderStage.period_format}}</span></li>
				</ul>
				<h4 style="line-height:50px;">服务方提供的验收相关材料</h4>
				<div class="jfimglist">
					<div v-for="(i,index) in datails.order.file"  :key="i" class="jfimg">
						<div class="jfimgbox">
							<img :src="i.file" alt="" srcset="" />
							<div>
								<span v-if="i.stage==1">{{index+1}},承认图</span>
								<span v-if="i.stage==2">{{index+1}},生产图</span>
								<p>{{i.create_time}}</p>
							</div>
						</div>
						<span>查看</span>
					</div>
				</div>
			</div> -->
			<div class="ReviewDatails2">
			   <div class="Reviewlist">
				   <div class="Reviewser">
					   <h4>需求方原因说明</h4> <span>{{datails.pay_time*1000 | dateFormat}}</span>
				   </div>
				   <div class="Reviewser1">
					   <h4>原因说明</h4>
					   <p>{{datails.demand_content}}</p>
					    <h4>相关问题附件</h4>
						<div style="display:flex;">
							<imglist :file="datails.demand_image"></imglist>
						</div>
				   </div>
			   </div>
			   <div class="Reviewlist">
				   <div class="Reviewser">
				   		<h4>服务方原因说明</h4>
				   </div>
				   <div class="fuwushuoming">
					   <div class="fuwushuoming1">
						   <div class="fuwushuoming2" style="color:#ff0000;">
							    提交材料剩余时间： <CountDown :endTime="datails.defense_expire_time*1000" color="#ff0000"/>
						   </div>
						   <div class="fuwushuoming3" @click="SubmitMaterials">
							   提交材料
						   </div>
					   </div>
				   </div>
			   </div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		OrderReviewDetail
	} from "@/api/api.js";
	import imglist from '@/common/imglist.vue'
	import CountDown from '@/common/CountDown.vue'
	export default {
	  components:{
		 CountDown,
		 imglist
	  },
	  name: 'HelloWorld',
	 //  components:{
		// rightsidebarImg  
	 //  },
	  data() {
	    return {
		   curNow:0 , //0为需求方信息 1为服务方信息
		   oruId:"",
		   datails:{
		   	o_id:"",
		   	stage:0,
		   	defense_expire_time:0,
		   	pay_time:0,
		   	demand_content:"",
		   	demand_image:[],
		   	order:{
		   		demand:{
		   			description:"",
		   			file:[],
		   			confirm_image:"",
		   			produce_image:""
		   		}
		   	}
		   },
		   demand:{
		   	description:"",
		   	file:[],
		   	confirm_image:"",
		   	produce_image:""
		   }
	    }
	  },
	  computed: {
		or_id() {
		   return this.$route.query.or_id || ''
		}
	  },
	  mounted() {
	     this.getdatails()
	  },
	  methods: {
		  fanhui(){
			this.$router.go(-1)
		  },
		  SubmitMaterials(){
			 const targetPath = '/serviceHome/serviceOrder/SubmitMaterials?oid='+this.or_id
			 if (this.$route.path !== targetPath) {
			 	this.$router.push(targetPath)
			 } 
		  },
		  getdatails(){
		  	OrderReviewDetail(this.or_id,{
		  		
		  	}).then(res=>{
		  		const apiData = (res && res.data && res.data.data) || {}
				const order = apiData.order || {}
				const demand = order.demand || {}
		  		this.datails = {
		  			...this.datails,
		  			...apiData,
		  			demand_image: Array.isArray(apiData.demand_image) ? apiData.demand_image : [],
		  			order: {
		  				...this.datails.order,
		  				...order,
		  				demand: {
		  					...this.datails.order.demand,
		  					...demand,
		  					file: Array.isArray(demand.file) ? demand.file : []
		  				}
		  			}
		  		}
				this.demand = this.datails.order.demand
		  	})
		  },
	  },
	}
</script>

<style scoped>
	.dingdan{
		width:1200px;
		margin:0 auto;
		padding:36px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.fh_button{
		width: 58px;
		height: 24px;
		line-height:24px;
		background: #1E3A8A;
		border-radius: 4px ;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		display:flex;
		align-items:center;
		justify-content:center;
	}
	.fh_button i{
		margin-right:5px;
	}
	.ReviewDatails{
		width:100%;
		background-color:#fff;
		border-radius:12px;
		padding:20px;
		box-sizing: border-box;
		margin-bottom:24px;
	}
	.dingwei{
		position:absolute;
		width:72px;
		height:30px;
		display:flex;
		align-items: center;
		justify-content:center;
		color: #666;
		bottom: 0;
		background:rgba(255,255,255,0.8);
		border-radius:6px 6px 0px 0px;
		margin-top:0 !important;
		padding-top:0 !important;
	}
	.ReviewH3{
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.Reviewdiv{
		width:100%;
		background: rgba(66,151,255,0.1);
		border-radius: 8px 8px 8px 8px;
		padding:20px;
		box-sizing: border-box;
		font-weight: 500;
		font-size: 16px;
		color: rgba(255,0,0,0.8);
		text-align: center;
		margin-top:18px;
	}
	.Reviewdiv1{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		margin-top:12px;
		word-wrap: break-word;
		white-space: pre-wrap;
		word-break: break-all;
	}
	.Reviewdiv2{
		width:100%;
		display:flex;
		justify-content:space-between;
		align-items: center;
		margin-top:24px;
	}
	.Reviewdiv2_1{
		width:50%;
		padding-right:10px;
		box-sizing: border-box;
	}
	.Reviewdiv2_1 h4{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.Reviewdiv2_1 div{
/* 		width:100%; */
		display:flex;
		align-items: center;
		margin-top:12px;
	}
	.Reviewdiv2_1 img{
		width:72px;
		height:72px;
		border-radius: 8px 8px 8px 8px;
		margin-right:16px;
	}
	.ReviewView{
		width:100%;
		margin-top:18px;
	}
	.ReviewView p{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.ReviewView p>span{
		font-weight: 400;
		font-size: 14px;
		color: rgba(255,0,0,0.8);
	}
	.ReviewUl{
		width:100%;
		display:flex;
		justify-content:space-between;
		align-items: center;
		margin-top:12px;
		font-weight: 400;
		font-size: 14px;
		color: #666666;
	}
	.ReviewUl span{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.jfimglist{
		width:100%;
		display: flex;
		flex-wrap:wrap;
	}
	.jfimg{
		width: 374px;
		height: 66px;
		background: rgba(30,58,138,0.15);
		border-radius: 12px 12px 12px 12px;
		display:flex;
		justify-content:space-between;
		align-items: center;
		margin-right:12px;
		margin-bottom:12px;
		padding:12px;
		box-sizing: border-box;
	}
	.jfimglist>div:nth-child(3n){
		margin-right:none;
	}
	.jfimgbox{
		display:flex;
		align-items:center;
	}
	.jfimgbox img{
		width:42px;
		height:42px;
		border-radius:6px;
		margin-right:5px;
	}
	.jfimgbox span{
		font-weight: 500;
		font-size: 14px;
		color: #1E3A8A;
	}
	.jfimgbox p{
		font-weight: 400;
		font-size: 12px;
		color: rgba(30,58,138,0.6);
	}
	.jfimg>span{
		font-weight: 400;
		font-size: 14px;
		color: #4297FF;
	}
	.Reviewlist{
		width: 588px;
		background: #FFFFFF;
		box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.05);
		border-radius: 12px 12px 12px 12px;
		padding:12px;
		box-sizing: border-box;
	}
	.ReviewDatails2{
		width:100%;
		display:flex;
		justify-content:space-between;
	}
	.Reviewser{
		width:100%;
		display:flex;
		justify-content:space-between; 
		align-items: center;
	}
	.Reviewser span{
		font-weight: 400;
		font-size: 12px;
		color: #666666;
	}
	.Reviewser1>h4{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
		line-height:30px;
	}
	.Reviewser1>p{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		margin-bottom:12px;
	}
	.ReviewFooter{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		flex-wrap:wrap;
		padding:30px 0px;
	}
	.ReviewFooterP{
		font-weight: 400;
		font-size: 14px;
		color: #FF0000;
		margin-bottom:10px;
	}
	.ReviewFooterH4{
		font-weight: 500;
		font-size: 16px;
		color: #999999;
	}
	.ReviewPS h4{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
		line-height:40px;
	}
	.ReviewZCF{
		display:flex;
		align-items:center;
	}
	.ReviewZCF img{
		width:24px;
		height:24px;
		margin-right:5px;
	}
	.ReviewZCF span{
		font-weight: 500;
		font-size: 14px;
		color: #333333;
	}
	.ReviewPSYJ{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
	}
	.fuwushuoming{
		width:100%;
		height:200px;
		display:flex;
		justify-content:center;
		align-items:center;
	}
	.fuwushuoming1{
		display:flex;
		justify-content:center;
		align-items:center;
		flex-wrap:wrap;
	}
	.fuwushuoming2{
		width:100%;
		display:flex;
		justify-content:center;
		align-items:center;
		font-weight: 500;
		font-size: 14px;
		color:rgb(255, 89, 0);
	}
	.fuwushuoming3{
		width: 120px;
		height: 40px;
		background: #1E3A8A;
		border-radius: 8px 8px 8px 8px;
		display:flex;
		justify-content:center;
		align-items:center;
		font-weight: 500;
		font-size: 16px;
		color: #FFFFFF;
		cursor:pointer;
		margin-top:24px;
	}
</style>